const EMPTY = '-';
const IST_OFFSET_MS = 5.5 * 60 * 60 * 1000;
const SHORT_MONTHS = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];

function toIstDate(value) {
  if (value == null || value === '') return null;

  const parsed = value instanceof Date ? new Date(value.getTime()) : new Date(value);
  if (Number.isNaN(parsed.getTime())) return null;

  return new Date(parsed.getTime() + IST_OFFSET_MS);
}

function shortDate(istDate) {
  const day = String(istDate.getUTCDate()).padStart(2, '0');
  const month = SHORT_MONTHS[istDate.getUTCMonth()];
  const year = istDate.getUTCFullYear();
  return `${day} ${month} ${year}`;
}

export function formatDate(value) {
  const istDate = toIstDate(value);
  return istDate ? shortDate(istDate) : EMPTY;
}

export function formatDateTime(value) {
  const istDate = toIstDate(value);
  if (!istDate) return EMPTY;

  const hours = istDate.getUTCHours();
  const minutes = String(istDate.getUTCMinutes()).padStart(2, '0');
  const period = hours >= 12 ? 'PM' : 'AM';
  const hour12 = hours % 12 || 12;

  return `${shortDate(istDate)}, ${hour12}.${minutes} ${period}`;
}
